import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campSnReorder: FaireAdCampaignEntity = {
  token: "camp_sn_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_strong_n_free",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 2000,
  startedRunningAt: "2025-11-03",
  segmentMetrics: {
    numReorderConversions: 15,
    salesDollars: 7322,
    totalAdsSpendDollars: 673,
    returnOnAdSpend: 10.88,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-25T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
